import type { DocNode } from '@atlaskit/adf-schema';
import type { PublicPluginAPI } from '@atlaskit/editor-common/types';
import type { JSONNode } from '@atlaskit/editor-json-transformer';
import type { AIPlugin } from '@atlassian/editor-plugin-ai';
import type { AiStreamingOrchestratorPlugin } from '@atlassian/editor-plugin-ai-streaming-orchestrator';

// delete this method when cleanup platform_editor_aifc_in_page_comment
/**
 * @private
 * @deprecated use api.core.actions.requestDocumentAsync() instead
 */
export const getDocument = (
	editorApi: PublicPluginAPI<[AIPlugin, AiStreamingOrchestratorPlugin]>,
): Promise<DocNode | undefined> => {
	return new Promise((resolve) => {
		try {
			editorApi.core.actions.requestDocument(
				(doc) => {
					resolve(doc as DocNode);
				},
				{ alwaysFire: true },
			);
		} catch {
			resolve(undefined);
		}
	});
};

export function isEmptyDocument(doc: DocNode): boolean {
	if (!doc.content || doc.content.length === 0) {
		return true;
	}

	if (doc.content.length === 1) {
		const node = doc.content[0];
		if (node.type === 'paragraph') {
			if (!node.content || node.content.length === 0) {
				return true;
			}

			return isOnlyWhitespaceContent(node.content);
		}

		if (node.type === 'heading') {
			if (!node.content || node.content.length === 0) {
				return true;
			}

			return isOnlyWhitespaceContent(node.content);
		}
	}

	return false;
}

function isOnlyWhitespaceContent(content: JSONNode[]): boolean {
	for (const node of content) {
		if (node.type === 'text') {
			if (node.text && node.text.trim().length > 0) {
				return false;
			}
		} else {
			return false;
		}
	}
	return true;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function chunkSubstr(str: string, size: number): any[] {
	const numChunks = Math.ceil(str.length / size);
	const chunks = new Array(numChunks);

	for (let i = 0, o = 0; i < numChunks; ++i, o += size) {
		chunks[i] = str.substring(o, o + size);
	}

	return chunks;
}
